import { Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import isTesting from '../utilities/isTesting';

export const fetchErrorsMiddleware: Middleware = store => next => action => {
  const regex = new RegExp('_failure|_FAILURE');
  
  if (regex.test(action.type) && !isTesting) {
    let errorMessage = 'Unknown error occurred.';
    
    if (action.payload instanceof Error) {
      errorMessage = action.payload.message || errorMessage;
    } else if (typeof action.payload === 'object' && action.payload.error) {
      errorMessage = action.payload.error;
    } else if (typeof action.payload === 'string') {
      errorMessage = action.payload;
    }
    
    toast.error(errorMessage);
    console.error(action.payload);
  }
  next(action);
};
